import uploadUrls from '../urls/upload'
import jqRequest from '../jqRequest'
import jq from "jquery"
export default {
    terminateUpload: false,
    /** 七牛上传。默认视频上传，fileType == 3，按照图片处理 **/
    fetchUpload(fileListItem, url, params, fileType, progressHandler, completeHandler) {
        // tokenParams = {
        // 	source: 2, //PC 1 、手机端 2
        // 	enterpriseCode: process.env.VUE_APP_NODE_CODE, //企业code
        // 	picType: 3, //picType 图片类型	1：内容焦点大图，2：内容列表缩略图，3:管理端上传的其他图片，用于上传后图片压缩剪裁判断-其中1、2 是需要压缩的
        // 	fileName: fileName, //文件名
        // };
        let self = this;

        jqRequest.requestWithTokenAndAuthorization(url, params).then(res => {
            if (res.suc == 1) {
                /** 七牛规定块写死4M **/
                var perBlockSize = 4 * 1024 * 1024;
                /** 上传块开始位置 **/
                var blockIndex = 0;
                /** 单次上传块不超过4M **/
                var currentBlockSize; // = Math.min( fileListItem.size - blockIndex, perBlockSize );
                /** 所有块创建后返回的ctx字符数组。 **/
                var ctxList = [];


                /** 单次上传片段不超过100K **/
                var perChunkSize = 100 * 1024;
                /** 上传片开始位置 **/
                var chunkIndex = 0;
                /** 当前上传片大小 **/
                var currentChunkSize;

                /** 默认上传host **/
                var tryTime = -1;
                var baseHostList = ["http://up-z2.qiniup.com", "http://up-z0.qiniu.com", "http://upload.qiniu.com",
                    "http://up-z1.qiniu.com", "http://up-z2.qiniu.com", "http://upload-z1.qiniu.com"
                ];
                var baseHost = "";

                /** 创建块，同时上传块中第一个片 **/
                function createBlock(host) {
                    currentBlockSize = Math.min(fileListItem.size - blockIndex, perBlockSize);
                    chunkIndex = 0;
                    currentChunkSize = Math.min(currentBlockSize - chunkIndex, perChunkSize);

                    if (host) baseHost = host;
                    else {
                        ++tryTime;
                        if (tryTime >= baseHostList.length) return;
                        baseHost = baseHostList[tryTime];
                    }
                    jq.ajax({
                        url: baseHost + '/mkblk/' + currentBlockSize,
                        type: 'POST',
                        data: fileListItem.slice(blockIndex + chunkIndex, blockIndex + currentChunkSize),
                        dataType: "json",
                        async: false,
                        cache: false,
                        contentType: "application/octet-stream",
                        processData: false,
                        headers: {
                            //"Host": "upload.qiniu.com",
                            "Content-Type": "application/octet-stream",
                            //"Content-Length": currentChunkSize,
                            "Authorization": "UpToken " + res.data.token
                        },
                        success: function (data) {
                            if (progressHandler) {
                                var percentage = parseInt(Number(blockIndex + chunkIndex + currentChunkSize) / Number(fileListItem.size) * 100) + "%";
                                progressHandler(percentage);
                            }

                            /** 记录块级上传ctx **/
                            ctxList.push(data.ctx);

                            /**  片索引自增 **/
                            chunkIndex += currentChunkSize;
                            /**  检查块中的片是否已满，未满，循环上传片 **/
                            if (chunkIndex < currentBlockSize) {
                                /**  循环上传片 **/
                                loopUploadChunk(data);
                                return;
                            }

                            /** 块中片已满，块索引自增 **/
                            blockIndex += currentBlockSize;

                            /** 是否所有块上传完毕 **/
                            if (blockIndex == fileListItem.size) {
                                createFile(data);
                            }
                            /**  全部块上传结束，创建文件 **/
                            else {
                                /** 创建下一个块 **/
                                tryTime = -1;
                                createBlock();
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("XMLHttpRequest.readyState " + XMLHttpRequest.readyState + "\n" +
                                "XMLHttpRequest.responseText " + XMLHttpRequest.responseText + "\n" +
                                "XMLHttpRequest.status " + XMLHttpRequest.status + "\n" +
                                "XMLHttpRequest.statusText " + XMLHttpRequest.statusText + "\n" +
                                "textStatus " + textStatus);
                            if (tryTime < baseHostList.length) createBlock();
                            else {
                                if (fileType == 3)
                                    console.log("上传图片失败。");
                                else
                                    console.log("上传媒体文件失败。");
                            }
                        }
                    });
                }
                /** 递归上传片段 **/
                function loopUploadChunk(data) {
                    currentChunkSize = Math.min(currentBlockSize - chunkIndex, perChunkSize);
                    jq.ajax({
                        url: data.host + '/bput/' + data.ctx + "/" + chunkIndex,
                        type: 'POST',
                        data: fileListItem.slice(blockIndex + chunkIndex, blockIndex + chunkIndex + currentChunkSize),
                        dataType: "json",
                        async: false,
                        cache: false,
                        contentType: "application/octet-stream",
                        processData: false,
                        headers: {
                            //"Host": data.host,
                            "Content-Type": "application/octet-stream",
                            //"Content-Length": currentChunkSize,
                            "Authorization": "UpToken " + res.data.token
                        },
                        success: function (data) {
                            if (progressHandler) {
                                var percentage = parseInt(Number(blockIndex + chunkIndex + currentChunkSize) / Number(fileListItem.size) * 100) + "%";
                                progressHandler(percentage);
                            }
                            /** 更新当前块级上传ctx **/
                            ctxList[ctxList.length - 1] = data.ctx;

                            /**  片索引自增 **/
                            chunkIndex += currentChunkSize;
                            /**  检查块中的片是否已满，未满，循环上传片 **/
                            if (chunkIndex < currentBlockSize) {
                                /**  循环上传片,延迟10毫秒，保证chrome进度条渲染 **/
                                setTimeout(function () {
                                    if (!self.terminateUpload) {
                                        loopUploadChunk(data)
                                    }
                                }, 10);
                                return;
                            }

                            /** 块中片已满，块索引自增 **/
                            blockIndex += currentBlockSize;

                            /** 是否所有块上传完毕 **/
                            if (blockIndex == fileListItem.size) {
                                /**  全部块上传结束，创建文件 **/
                                tryTime = -1;
                                createFile(data);
                            } else {
                                /** 创建下一个块 **/
                                tryTime = -1;
                                createBlock(data.host);
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("XMLHttpRequest.readyState " + XMLHttpRequest.readyState + "\n" +
                                "XMLHttpRequest.responseText " + XMLHttpRequest.responseText + "\n" +
                                "XMLHttpRequest.status " + XMLHttpRequest.status + "\n" +
                                "XMLHttpRequest.statusText " + XMLHttpRequest.statusText + "\n" +
                                "textStatus " + textStatus);
                            if (fileType == 3)
                                console.log("上传图片失败。");
                            else
                                console.log("上传媒体文件失败。");
                        }
                    });
                }

                /**  全部片段上传结束，创建文件 **/
                function createFile(data) {
                    var host = tryTime < 0 ? data.host : baseHostList[tryTime];
                    jq.ajax({
                        url: host + '/mkfile/' + fileListItem.size,
                        type: 'POST',
                        data: ctxList.toString(),
                        dataType: "json",
                        async: false,
                        cache: false,
                        contentType: "text/plain",
                        processData: false,
                        headers: {
                            //"Host": "upload.qiniu.com",
                            "Content-Type": "text/plain",
                            // "Content-Length": ctxList.toString().length,
                            "Authorization": "UpToken " + res.data.token
                        },
                        success: function (finalData) {
                            if (finalData.suc == 1) {
                                if (fileType == 3) {
                                    /** 判断图片压缩是否已完成，如果完成，回调
                                     * 这样做是为了防止，图片压缩后，后台用新的图片替换就图片导致图片路径变化
                                     * isConvert：是否执行图片压缩，不执行，直接回调；执行，等待图片压缩完成后，再回调
                                     * **/
                                    //completeHandler( { resourceId: finalData.data.pictureId, path: finalData.data.accessUrl } );
                                    if (finalData.data.isConvert == true) {
                                        progressHandler("压缩中...");
                                        self.loopImageUploadComplete({
                                            suc: 1,
                                            resourceId: finalData.data.pictureId,
                                            url: finalData.data.accessUrl
                                        }, completeHandler);
                                    } else {
                                        completeHandler({
                                            suc: 1,
                                            resourceId: finalData.data.pictureId,
                                            url: finalData.data.accessUrl
                                        });
                                    }
                                } else {
                                    progressHandler("压缩中...");
                                    self.loopVideoUploadComplete(
                                        {
                                            suc: 1,
                                            resourceId: finalData.data.streamId,
                                            url: '',
                                        },
                                        completeHandler
                                    );
                                }
                            } else {
                                console.log("上传媒体文件失败。\n" + finalData.message);
                                completeHandler({
                                    suc: 0,
                                });
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("XMLHttpRequest.readyState " + XMLHttpRequest.readyState + "\n" +
                                "XMLHttpRequest.responseText " + XMLHttpRequest.responseText + "\n" +
                                "XMLHttpRequest.status " + XMLHttpRequest.status + "\n" +
                                "XMLHttpRequest.statusText " + XMLHttpRequest.statusText + "\n" +
                                "textStatus " + textStatus);
                            if (++tryTime < baseHostList.length) createFile(data);
                            else {
                                if (fileType == 3)
                                    console.log("上传图片失败。");
                                else
                                    console.log("上传媒体文件失败。");

                                completeHandler({
                                    suc: 0,
                                });
                            }
                        }
                    });
                }
                createBlock();
            } else {
                console.log("获取七牛云上传token失败\n" + res.message);
                completeHandler({
                    suc: 0,
                });
            }
        })
    },
    //压缩图片循环查询
    loopImageUploadComplete(data, callback) {
        let self = this;
        let params = {
            pictureId: data.resourceId,
            t: new Date().getTime()
        };
        let url = uploadUrls.imageCompression;
        setTimeout(function () {
            jqRequest.requestWithTokenAndAuthorization(url, params).then((res) => {
                if (res.suc == 1 && res.data && res.data.convertStatus == 1) {
                    /** 图片路径更新完毕，回调 **/
                    data.url = res.data.convertAccessUrl;
                    callback(data);
                } else {
                    /** 未完成，递归 **/
                    if (!self.terminateUpload) {
                        self.loopImageUploadComplete(data, callback);
                    }
                }
            });
        }, 1000);
    },
    /** 视频上传七牛后台，递归调用视频详情后台接口，获取视频地址
     * 这么做，是因为后台压缩图片后，会用新图片替换就图片，因而图片路径变更
     * 所以要等待最终图片路径生成后返回图片路径
     * data：{
     *      resourceId: 图片素材id,
     *      path: 图片路径
     * },* callback：页面上注册的上传回调
     * **/
    loopVideoUploadComplete(data, callback) {
        let self = this;
        let params = {
            streamId: data.resourceId,
            t: new Date().getTime(),
        };
        setTimeout(function () {
            var url = uploadUrls.videoCompression;
            jqRequest.requestWithAuthorization(url, params).then((res) => {
                if (res.suc == 1 && res.data && res.data.convertStatus == 1) {
                    /** 压缩完毕，回调 **/
                    data.url = res.data.url;
                    callback(data);
                } else {
                    /** 未完成，递归 **/
                    if (!self.terminateUpload) {
                        self.loopVideoUploadComplete(data, callback);
                    }
                }
            });
        }, 1000);
    },
    // 七牛上传图片
    fetchUploadPic(fileListItem, progressHandler, completeHandler) {
        var self = this;
        let fileName = fileListItem.name;
        let fileType = 3;
        var tokenParams = {
            source: 2,
            enterpriseCode: process.env.VUE_APP_NODE_CODE,
            picType: 3,
            fileName: fileName,
        };

        let url = uploadUrls.getPicUploadToken + "?datetimeflag=" + new Date().getTime();
        self.fetchUpload(fileListItem, url, tokenParams, fileType, progressHandler, completeHandler);
    },
    // 七牛上传视频
    fetchUploadVideo(fileListItem, progressHandler, completeHandler) {
        var self = this;
        let fileName = fileListItem.name;
        let fileType = 1;
        var tokenParams = {
            source: 2,
            enterpriseCode: process.env.VUE_APP_NODE_CODE,
            type: 1, //1为视频，2为音频
            fileName: fileName,
        };
        let url = uploadUrls.getVideoUploadToken + "?datetimeflag=" + new Date().getTime();
        self.fetchUpload(fileListItem, url, tokenParams, fileType, progressHandler, completeHandler);
    },
    // 七牛上传音频
    fetchUploadAudio(fileListItem, progressHandler, completeHandler) {
        var self = this;
        let fileName = fileListItem.name;
        let fileType = 1;
        var tokenParams = {
            source: 2,
            enterpriseCode: process.env.VUE_APP_NODE_CODE,
            type: 2, //1为视频，2为音频
            fileName: fileName,
        };
        let url = uploadUrls.getVideoUploadToken + "?datetimeflag=" + new Date().getTime();
        self.fetchUpload(fileListItem, url, tokenParams, fileType, progressHandler, completeHandler);
    },
    // 停止上传
    stopUpload() {
        this.terminateUpload = true;
    },
    // 开始上传
    startUpload() {
        this.terminateUpload = false;
    },
}